/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Form,
  message,
  Radio,
  Spin,
  Modal,
  Select,
} from "antd";
import {
  capitalize,
  checkAlphabets,
  checkSpace,
  checkSpecialCharacter,
} from "../../../../../utils";

import API from "../../../../../api";
import urls from "../../../../../api/urls";
import { ReactComponent as Reason } from "../../../../../assests/images/SVG/check.svg";
import "../style.scss";
import cross_button from "../../../../../assests/images/CrossButton.svg";
import Smcs_Loader from "../../../../../assests/images/loader-new.gif";
import PinCodeValidator from "../../../../../components/PincodeValidator";
import { customerOnboardingAPI } from "../../../../../api/LeadApi";
import CreateKYC from "../../../../../components/CreateKYC";
import constants from "../../../../../constants/constants";

const { VERIFY_GST } = urls;
const { ROLES } = constants;
const { ROLE_HOMARKETING } = ROLES;
export const BusineesDetails = ({
  handleStepsChange = () => {},

  patchClient,
  getData,
}) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [isGSTRegister, setIsGSTRegister] = useState(true);

  const typeOfBusinessOptions = [
    {
      value: "Individual",
      label: "Individual",
    },
    {
      value: "Proprietorship",
      label: "Proprietorship",
    },
    {
      value: "Private limited",
      label: "Private limited",
    },
    {
      value: "Public limited",
      label: "Public limited",
    },
    {
      value: "LLP",
      label: "LLP",
    },
    {
      value: "Partnership",
      label: "Partnership",
    },
  ];

  useEffect(() => {
    if (getData) {
      const gst =
        getData?.kycDocuments.find((doc) => doc.idType === "GST")?.idNumber ||
        null;
      const pan =
        getData?.kycDocuments.find((doc) => doc.idType === "PAN")?.idNumber ||
        null;
      const aadhaar =
        getData?.kycDocuments.find(
          (doc) => doc.idType === "AADHAAR" || doc.idType === "AADHAR"
        )?.idNumber || null;

      const tan =
        getData?.kycDocuments.find((doc) => doc.idType === "TAN")?.idNumber ||
        null;

      const address = getData?.addresses?.find(
        (e) => e?.type?.toUpperCase() === "DEFAULT"
      );

      setIsGSTRegister(gst ? true : false);
      form.setFieldsValue({
        street: address?.street,
        area: address?.area,
        businessName: getData?.businessDetail?.businessName || null,
        natureOfBusiness: getData?.businessDetail?.natureOfBusiness || null,
        email: getData?.emails?.find(
          (e) => e?.type?.toLowerCase() === "default"
        )?.email,
        PAN: pan,
        number: getData?.contactNumbers?.find(
          (e) => e?.type?.toLowerCase() === "default"
        )?.number,
        personalNumber: getData?.contactNumbers?.find(
          (e) => e?.type?.toLowerCase() === "personal"
        )?.number,
        GST: gst,
        AADHAR: aadhaar,
        TAN: tan,
        gstRegistred: getData?.kycDocuments?.length === 0 || gst ? true : false,
        orgName: getData?.orgName,
        pincode: address?.pincode,
      });
    } else {
      form.setFieldValue("gstRegistred", true);
    }
  }, [getData]);

  const checkGST = async (event) => {
    if (event.target.value.length > 14) {
      let response = await API.Api(
        VERIFY_GST + event.target.value.toUpperCase()
      ).get();
      if (response.status) {
        if (response?.response?.data?.result) {
          setCheckStatus(true);
          form.setFieldValue(
            "orgName",
            response?.response?.data?.result?.gstnDetailed?.tradeNameOfBusiness
          );
          form.setFieldValue("gstin", event.target.value.toUpperCase());
          let clientName = form.getFieldValue("clientName");
          if (
            clientName?.toLowerCase() !==
            response?.response?.data?.result?.gstnDetailed?.tradeNameOfBusiness.toLowerCase()
          ) {
            setModalVisible(true);
          }
        } else {
          form.setFieldValue("orgName", form.getFieldValue("clientName"));
        }
      } else {
        form.setFieldValue("orgName", form.getFieldValue("clientName"));
      }
    } else {
      setCheckStatus(false);
    }
  };
  const updateClientName = () => {
    let orgName = form.getFieldValue("orgName");
    form.setFieldValue("clientName", orgName);
    setModalVisible(false);
  };

  const createBasicDetails = async (val) => {
    setLoading(true);
    let clientLeadId = localStorage.getItem("clientLeadId");
    // let payload = {
    //   customerType: "CLIENT",
    //   reference: JSON.parse(localStorage.getItem("userinfo"))?.roles?.includes(
    //     ROLE_HOMARKETING
    //   )
    //     ? "MARKETING"
    //     : "CP",
    //   businessDetail: {
    //     natureOfBusiness: val?.natureOfBusiness,
    //     businessName: val?.businessName,
    //   },
    //   orgName: val?.orgName,
    //   source: "website",
    //   pincode: val?.pincode,
    //   emails: [{ email: val?.email, type: "default" }],
    //   contactNumbers: [
    //     { number: val?.number, type: "default" },
    //     { number: val?.personalNumber, type: "personal" },
    //   ].filter((contact) => contact.number),
    //   addresses: [
    //     {
    //       street: val?.street,
    //       area: val?.area,
    //       pincode: val?.pincode,
    //       type: "DEFAULT",
    //     },
    //   ],
    //   kycDocuments: [
    //     {
    //       idType: "GST",
    //       idNumber: val?.GST,
    //       isVerified: false,
    //     },
    //     {
    //       idType: "PAN",
    //       idNumber: val?.PAN,
    //       isVerified: false,
    //     },
    //     {
    //       idType: "AADHAR",
    //       idNumber: val?.AADHAR,
    //       isVerified: false,
    //     },
    //     {
    //       idType: "TAN",
    //       idNumber: val?.TAN,
    //       isVerified: false,
    //     },
    //   ].filter((doc) => doc.idNumber),
    // };

    const userInfo = JSON.parse(localStorage.getItem("userinfo"));
    const selectedCompany = JSON.parse(localStorage.getItem("selectedCompany"));
    const isMarketing = userInfo?.roles?.includes(ROLE_HOMARKETING);

    const payload = {
      customerType: "CLIENT",
      reference: isMarketing ? "MARKETING" : "CP",
      source: "website",
      ...(val?.orgName && { orgName: val.orgName }),
      ...(val?.pincode && { pincode: val.pincode }),

      ...(val?.natureOfBusiness || val?.businessName
        ? {
            businessDetail: {
              ...(val?.natureOfBusiness && {
                natureOfBusiness: val.natureOfBusiness,
              }),
              ...(val?.businessName && { businessName: val.businessName }),
            },
          }
        : {}),

      ...(val?.email && {
        emails: [{ email: val.email, type: "default" }],
      }),

      ...(val?.number || val?.personalNumber
        ? {
            contactNumbers: [
              val?.number && { number: val.number, type: "default" },
              val?.personalNumber && {
                number: val.personalNumber,
                type: "personal",
              },
            ].filter(Boolean),
          }
        : {}),

      ...(val?.street || val?.area || val?.pincode
        ? {
            addresses: [
              {
                ...(val?.street && { street: val.street }),
                ...(val?.area && { area: val.area }),
                ...(val?.pincode && { pincode: val.pincode }),
                type: "DEFAULT",
              },
            ],
          }
        : {}),

      ...(val?.GST || val?.PAN || val?.AADHAR || val?.TAN
        ? {
            kycDocuments: [
              val?.GST && {
                idType: "GST",
                idNumber: val.GST,
                isVerified: false,
              },
              val?.PAN && {
                idType: "PAN",
                idNumber: val.PAN,
                isVerified: false,
              },
              val?.AADHAR && {
                idType: "AADHAR",
                idNumber: val.AADHAR,
                isVerified: false,
              },
              val?.TAN && {
                idType: "TAN",
                idNumber: val.TAN,
                isVerified: false,
              },
            ].filter(Boolean),
          }
        : {}),
      metadata: [
        {
          key: "CP_ID",
          value: userInfo?.cpId?.toString(),
        },
        {
          key: "COMPANY_ID",
          value: selectedCompany?.key,
        },
      ],
    };

    const emailAvailability =
      await customerOnboardingAPI.checkEmailAvailability(
        payload?.emails?.[0]?.email
      );
    if (emailAvailability?.status) {
      let data = emailAvailability?.response?.data;
      if (!data) {
        message.error(
          emailAvailability?.response?.data?.message || "Email already exists."
        );
        setLoading(false);
        return;
      }
    }
    if (clientLeadId === null) {
      let response = await customerOnboardingAPI.createLead(payload);

      if (response?.status) {
        setLoading(false);

        handleStepsChange();
        message.success(response?.message || "Client added successfully");

        localStorage.setItem(
          "clientLeadId",
          response?.response?.data?.data?.customerId
        );
      } else {
        message.error(response?.response?.data?.message || "Network error");
        setLoading(false);
      }
    } else {
      setLoading(false);
      patchClient(payload);
    }
  };
  const cancelReset = () => {
    localStorage.removeItem("clientLeadId");
    window.history.back();
  };

  function handleIsGSTRegistered(params) {
    setIsGSTRegister(params.target.value);
  }

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div>
        <Form
          className="global-form profile-container-form pl-4 pr-4"
          layout="vertical"
          form={form}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          onFinish={createBasicDetails}
          initialValues={{ gstRegistred: true }}
        >
          <Row gutter={40} className="global-form-row">
            {/*<Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="clientName"
                label="Client name"
                rules={[
                  {
                    message: "Please enter client name",
                    required: true,
                  },
                  () => ({
                    validator(rule, value = "") {
                      if (value.substring(1, 0) === " ") {
                        return Promise.reject("Invalid client name ");
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
                onKeyPress={(event) => {
                  if (checkAlphabets(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  // style={{ textTransform: "capitalize" }}
                  placeholder="Enter client name"
                  // disabled={getData ? true : false}
                  onInput={(e) => (e.target.value = capitalize(e.target.value))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="gstRegistred"
                label={"Is GST registred"}
                rules={[
                  {
                    required: true,
                    message: "Please select ",
                  },
                ]}
              >
                <Radio.Group
                  onChange={(e) => handleIsGSTRegistered(e)}
                  className="calculater-container-div-radio"

                  // disabled={getData?.organizationDetails?.gst !== null && true}
                >
                  <Radio value={true} className="radioButton">
                    Yes
                  </Radio>
                  <Radio value={false} className="radioButton">
                    No
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
             {isGSTRegister && (
              <Col xs={20} sm={20} md={12} lg={12} xl={12}>
                <Form.Item
                  name="gst"
                  label="GSTIN"
                  rules={[
                    {
                      message: "Please enter GSTIN",
                      required: true,
                    },
                    {
                      pattern:
                        /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/g,
                      message: "Invalid GSTIN",
                    },
                  ]}
                  className="accpickupPincodeParent"
                >
                  <Input
                    className="accpickupPincode"
                    placeholder="Enter GSTIN"
                    suffix={checkStatus ? <Reason /> : ""}
                    maxLength={15}
                    onChange={checkGST}
                    // disabled={getData ? true : false}
                    onKeyPress={(e) => {
                      if (/[^A-Za-z0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onInput={(e) =>
                      (e.target.value = e.target.value.toUpperCase())
                    }
                  />
                </Form.Item>
              </Col>
            )}
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="pan"
                label={
                  <span className="calculater-container-pikpin">
                    PAN number
                  </span>
                }
                onKeyPress={(event) => {
                  if (checkSpecialCharacter(event) || checkSpace(event)) {
                    event.preventDefault();
                  }
                }}
                rules={[
                  {
                    required: !isGSTRegister ? true : false,
                    message: "Enter value",
                  },
                  {
                    pattern: new RegExp(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/g),
                    message: "Enter a valid PAN number",
                    validateTrigger: "onSubmit",
                  },
                ]}
              >
                <Input
                  placeholder="Enter PAN number"
                  // disabled={getData?.organizationDetails?.pan !== null && true}
                  type="text"
                  maxLength={10}
                  onInput={(e) =>
                    (e.target.value = e.target.value.toUpperCase())
                  }
                />
              </Form.Item>
            </Col> */}

            <CreateKYC
              form={form}
              orgName={"Client"}
              getData={getData}
              required={getData?.quotations?.length > 0}
            />
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="natureOfBusiness"
                label="Business Type"
                rules={[
                  {
                    required: getData?.quotations?.length > 0,
                    message: "Please select business type",
                  },
                ]}
              >
                <Select
                  placeholder="Select business type"
                  options={typeOfBusinessOptions}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="businessName"
                label="Business Name"
                rules={[
                  {
                    required: getData?.quotations?.length > 0,
                    message: "Please enter business name",
                  },
                ]}
              >
                <Input
                  placeholder="Enter business name"
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Form.Item>
            </Col>

            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="addressLine1"
                label="Address line 1"
                rules={[
                  {
                    message: "Please enter address line 1",
                    required: true,
                  },
                  () => ({
                    validator(rule, value = "") {
                      if (value.substring(1, 0) === " ") {
                        return Promise.reject("Invalid address line 1");
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                <Input
                  placeholder="Enter Address line 1"
                  // disabled={getData ? true : false}
                  maxLength={500}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="addressLine2"
                label="Address line 2"
                rules={
                  getData
                    ? []
                    : [
                        () => ({
                          validator(rule, value = "") {
                            if (value.substring(1, 0) === " ") {
                              return Promise.reject("Invalid address line 2");
                            } else {
                              return Promise.resolve();
                            }
                          },
                        }),
                      ]
                }
              >
                <Input
                  placeholder="Enter Address line 2"
                  // disabled={getData ? true : false}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <PinCodeValidator formName={"pincode"} value={getData?.pincode} />
            </Col> */}

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="email"
                label="Email-ID"
                rules={[
                  {
                    message: "Please enter email",
                    required: getData?.quotations?.length > 0,
                  },
                  {
                    type: "email",
                    message: "The input is not valid E-mail",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Email"
                  disabled={getData?.status?.toLowerCase() === "approved"}
                  onInput={(e) =>
                    (e.target.value = e.target.value.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="number"
                label="Mobile number"
                rules={[
                  {
                    required: getData?.quotations?.length > 0,
                    message: "Please enter primary mobile number",
                  },
                  {
                    pattern: /^([1-9]{1}[0-9]{9}){0,10}$/g,
                    message: "Invalid mobile number",
                  },
                ]}
              >
                <Input
                  placeholder="Enter phone number"
                  onKeyPress={(e) => {
                    if (/[^0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length >= 10) {
                      e.preventDefault();
                    }
                  }}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                  maxLength={10}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="personalNumber"
                label="Secondary phone number"
                onKeyPress={(e) => {
                  if (/[^0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                  if (e.target.value.length >= 10) {
                    e.preventDefault();
                  }
                }}
                rules={[
                  {
                    pattern: /^([1-9]{1}[0-9]{9}){0,10}$/g,
                    message: "Invalid mobile number",
                  },
                ]}
              >
                <Input
                  placeholder="Enter secondary phone number"
                  maxLength={10}
                  onKeyPress={(e) => {
                    if (/[^0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length >= 10) {
                      e.preventDefault();
                    }
                  }}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Form.Item>
            </Col>
          </Row>
          <hr className="divider" />
          <div className="flex-end mt-1">
            <Button className="cancel-btn ml-1 w-15" onClick={cancelReset}>
              CANCEL
            </Button>
            {getData?.status?.toLowerCase() === "approved" ? (
              <Button
                id="saveNContinue"
                onClick={() => handleStepsChange()}
                className="save-btn  ml-1"
              >
                NEXT
              </Button>
            ) : (
              <Button
                htmlType="submit"
                className="save-btn w-15 ml-1"
                // onClick={handleStepsChange}
              >
                CONTINUE
              </Button>
            )}
          </div>
        </Form>
        <Modal
          open={modalVisible}
          footer={null}
          onCancel={() => setModalVisible(false)}
          width={380}
          destroyOnClose
          closeIcon={<img src={cross_button} />}

          // maskClosable={false}
        >
          <Row className="global-form-row center" gutter={37}>
            <div style={{ width: "380px", padding: "2rem" }}>
              <div className="mb-1">
                Do you want to update client name as per GST Validated name?
              </div>
              <div className="center">
                <Button
                  className="btn-style"
                  onClick={() => setModalVisible(false)}
                >
                  NO
                </Button>
                <Button
                  type="primary ml-1"
                  className="save-btn"
                  onClick={updateClientName}
                >
                  YES
                </Button>
              </div>
            </div>
          </Row>
        </Modal>
      </div>
    </Spin>
  );
};

export default BusineesDetails;
